class AccordionManager {
  constructor() {
    this.initializedSections = new Set();
    this.TRANSITION_DURATION = 300;
  }

  initSection(sectionId) {
    if (this.initializedSections.has(sectionId)) return;
    this.initializedSections.add(sectionId);

    const sectionElement = document.querySelector(
      `[data-accordion-section="${sectionId}"]`
    );
    if (!sectionElement) return;

    const buttons = sectionElement.parentElement.querySelectorAll(
      `[data-accordion-section="${sectionId}"] [data-accordion-toggle]`
    );
    const collapses = sectionElement.parentElement.querySelectorAll(
      `[data-accordion-section="${sectionId}"] .accordion-collapse`
    );

    // Initialize all accordions as closed
    collapses.forEach((collapse) => {
      collapse.style.height = "0";
    });

    buttons.forEach((button) => {
      button.addEventListener("click", (evt) =>
        this.handleAccordion(evt, sectionId)
      );
    });
  }

  handleAccordion(evt, sectionId) {
    const button = evt.currentTarget;
    const isExpanded = button.getAttribute("aria-expanded") === "true";
    const targetId = button.getAttribute("aria-controls");
    const targetCollapse = document.getElementById(targetId);

    if (targetCollapse.classList.contains("collapsing")) return;

    // Get all accordions in this section
    const sectionElement = document.querySelector(
      `[data-accordion-section="${sectionId}"]`
    );
    const allButtons = sectionElement.parentElement.querySelectorAll(
      `[data-accordion-section="${sectionId}"] [data-accordion-toggle]`
    );
    const allCollapses = sectionElement.parentElement.querySelectorAll(
      `[data-accordion-section="${sectionId}"] .accordion-collapse`
    );

    // Close all other accordions in this section
    allButtons.forEach((btn) => {
      if (btn !== button) {
        const otherTargetId = btn.getAttribute("aria-controls");
        const otherCollapse = document.getElementById(otherTargetId);

        if (otherCollapse.classList.contains("show")) {
          btn.setAttribute("aria-expanded", "false");
          otherCollapse.classList.add("collapsing");
          otherCollapse.classList.remove("show");

          // Batch DOM reads to avoid forced reflow
          requestAnimationFrame(() => {
            const height = otherCollapse.scrollHeight;
            otherCollapse.style.height = `${height}px`;
            requestAnimationFrame(() => {
              otherCollapse.style.height = "0";
            });
          });

          setTimeout(() => {
            otherCollapse.classList.remove("collapsing");
            btn.closest(".accordion_item-basic").classList.remove("active");
          }, this.TRANSITION_DURATION);
        }
      }
    });

    // Toggle current accordion
    if (!isExpanded) {
      button.setAttribute("aria-expanded", "true");
      targetCollapse.classList.add("collapsing", "show");
      button.closest(".accordion_item-basic").classList.add("active");

      targetCollapse.style.height = "0";

      // Batch DOM reads to avoid forced reflow
      requestAnimationFrame(() => {
        const contentHeight = targetCollapse.scrollHeight;
        targetCollapse.style.height = `${contentHeight}px`;
        setTimeout(() => {
          targetCollapse.classList.remove("collapsing");
          targetCollapse.style.height = "auto";
        }, this.TRANSITION_DURATION);
      });
    } else {
      button.setAttribute("aria-expanded", "false");
      targetCollapse.classList.add("collapsing");
      targetCollapse.classList.remove("show");

      // Batch DOM reads to avoid forced reflow
      requestAnimationFrame(() => {
        const height = targetCollapse.scrollHeight;
        targetCollapse.style.height = `${height}px`;
        requestAnimationFrame(() => {
          targetCollapse.style.height = "0";
          setTimeout(() => {
            targetCollapse.classList.remove("collapsing");
            button.closest(".accordion_item-basic").classList.remove("active");
          }, this.TRANSITION_DURATION);
        });
      });
    }
  }
}

// Initialize the manager
const accordionManager = new AccordionManager();

// Expose initialization to liquid
window.initAccordionSection = (sectionId) => {
  accordionManager.initSection(sectionId);
};

document.addEventListener("DOMContentLoaded", function () {
  // === Lazy-load videos ===
  const videoLazyObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const card = entry.target;
        const video = card.querySelector("video.review-video");
        if (!video) return;

        if (entry.isIntersecting) {
          // Only load if video has been played before (has data-loaded attribute)
          if (video.hasAttribute("data-loaded") && !video.src) {
            const realSrc = video.dataset.src;
            if (realSrc) {
              video.src = realSrc;
              video.load();
            }
          }
        } else {
          // Far away: pause & release buffer
          if (!video.paused) video.pause();
          if (video.src && !video.hasAttribute("data-keep-loaded")) {
            video.removeAttribute("src");
            video.load(); // drop the memory buffer
          }
        }
      });
    },
    { root: null, rootMargin: "300px" }
  );

  // Define the function globally before any templates use it
  window.formatReviewDate = function (dateString) {
    if (!dateString) return "";

    const reviewDate = new Date(dateString);
    if (isNaN(reviewDate.getTime())) return dateString; // Return original if invalid

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    reviewDate.setHours(0, 0, 0, 0);

    const diffTime = today - reviewDate;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 0) return "Today";
    if (diffDays === 1) return "1 day ago";
    if (diffDays <= 7) return `${diffDays} days ago`;

    // For dates older than 7 days, return in a readable format
    return reviewDate.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  // Fill all review dates without document.write
  document.querySelectorAll("[data-review-date]").forEach(function (el) {
    const rawDate = el.getAttribute("data-review-date");
    el.textContent = formatReviewDate(rawDate);
  });

  // Show more/less functionality
  function initShowMoreButtons() {
    document.querySelectorAll("[data-description]").forEach((descriptionEl) => {
      // Batch DOM reads to avoid forced reflow
      requestAnimationFrame(() => {
        // Only add button if content is truncated
        if (descriptionEl.scrollHeight > descriptionEl.clientHeight) {
          const btn = document.createElement("button");
          btn.className = "show-more-btn";
          btn.textContent = "Show more";
          btn.addEventListener("click", (e) => {
            e.preventDefault();
            descriptionEl.classList.toggle("expanded");
            btn.textContent = descriptionEl.classList.contains("expanded")
              ? "Show less"
              : "Show More";
          });

          // Append button after the text
          descriptionEl.insertAdjacentElement("afterend", btn);
        }
      });
    });
  }

  // Call the function after DOM is loaded
  initShowMoreButtons();

  const sections = document.querySelectorAll(".reviews-section");

  sections.forEach((section) => {
    const slider = section.querySelector(".reviews-slider");
    const cards = slider.querySelectorAll(".review-card:not(.clone)");

    if (!cards.length) return;

    let isInitialized = false;

    // Use Intersection Observer to only initialize when section comes into view
    const initObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !isInitialized) {
            initializeSlider();
            isInitialized = true;
            initObserver.disconnect(); // Stop observing after initialization
          }
        });
      },
      {
        rootMargin: "50px", // Start initializing 50px before section is visible
      }
    );

    initObserver.observe(section);

    function initializeSlider() {
      // Detect mobile device at slider initialization time
      const isMobileSlider = window.innerWidth <= 999;

      // Mark original cards for reference
      cards.forEach((card) => card.classList.add("original"));

      // Batch DOM reads to avoid forced reflows
      let cardWidth, originalContentWidth;

      function updateCardDimensions() {
        const gap = parseInt(window.getComputedStyle(slider).gap) || 15;
        cardWidth = cards[0].offsetWidth + gap;
        originalContentWidth = cardWidth * cards.length;
      }

      // Initial dimension calculation
      updateCardDimensions();

      // Optimized cloning: Use minimal clones for better performance
      // Only 2 clones per side (4 total) instead of viewport-based calculation
      function createClones() {
        // Clear old clones
        slider
          .querySelectorAll(".review-card.clone")
          .forEach((clone) => clone.remove());

        // Use fixed clone count for better performance
        const cloneCount = isMobileSlider ? 3 : 6;

        // Clone for right side (at the end)
        for (let i = 0; i < cloneCount; i++) {
          if (cards[i]) {
            const rightClone = cards[i].cloneNode(true);
            rightClone.classList.add("clone", "right");
            // Mark clones to prevent video loading
            rightClone.setAttribute("data-clone", "true");
            slider.appendChild(rightClone);
          }
        }

        // Clone for left side (at the beginning)
        for (let i = 0; i < cloneCount; i++) {
          const cardIndex = cards.length - 1 - i;
          if (cards[cardIndex]) {
            const leftClone = cards[cardIndex].cloneNode(true);
            leftClone.classList.add("clone", "left");
            // Mark clones to prevent video loading
            leftClone.setAttribute("data-clone", "true");
            slider.prepend(leftClone);
          }
        }

        // Initialize videos in cloned cards
        setTimeout(initializeAllVideos, 50);
      }

      createClones();

      window.addEventListener(
        "resize",
        debounce(() => {
          updateCardDimensions();
          createClones();
        }, 300),
        {
          passive: true,
        }
      );

      // Initialize slider state
      const allCards = slider.querySelectorAll(".review-card");
      let isDragging = false;
      let startPos = 0;
      let currentTranslate = 0;
      let prevTranslate = 0;
      let animationID;
      const autoScrollSpeed = 0.5;
      let isAutoScrolling = true;

      // Set initial position to show original content (centered)
      currentTranslate = -originalContentWidth;
      prevTranslate = currentTranslate;
      slider.style.transform = `translateX(${currentTranslate}px)`;

      // Optimize slider with GPU acceleration
      if (isMobileSlider) {
        slider.style.willChange = "transform";
      }

      // Event listeners - optimize for mobile
      if (isMobileSlider) {
        slider.addEventListener("touchstart", touchStart, { passive: false });
        slider.addEventListener("touchmove", touchMove, { passive: false });
        slider.addEventListener("touchend", touchEnd, { passive: true });
      } else {
        slider.addEventListener("touchstart", touchStart, { passive: false });
        slider.addEventListener("touchmove", touchMove, { passive: false });
        slider.addEventListener("touchend", touchEnd);
      }

      slider.addEventListener("mousedown", pointerDown);
      slider.addEventListener("mousemove", pointerMove);
      slider.addEventListener("mouseup", pointerUp);
      slider.addEventListener("mouseleave", pointerUp);

      // Video controls
      let currentlyPlaying = null;

      // Initialize all videos (original and clones)
      function initializeAllVideos() {
        // Initialize video click handlers
        initializeVideoHandlers();
      }

      // Initialize video click handlers
      function initializeVideoHandlers() {
        const videoWrappers = slider.querySelectorAll("[data-video-handle]");

        videoWrappers.forEach((videoWrapper) => {
          // Skip if already has listener
          if (videoWrapper.hasAttribute("data-handler-added")) return;

          // Skip clones to improve performance
          const card = videoWrapper.closest(".review-card");
          if (card && card.hasAttribute("data-clone")) return;

          videoWrapper.setAttribute("data-handler-added", "true");
          const videoContainer = videoWrapper.querySelector(".video-container");
          const playOverlay = videoWrapper.querySelector(".video-play-overlay");
          const thumbnail = videoWrapper.querySelector(".video-thumbnail");

          if (!videoContainer) return;

          // Add click event to play overlay
          if (playOverlay) {
            playOverlay.addEventListener("click", function (e) {
              e.stopPropagation();
              toggleVideoPlayback(videoWrapper, videoContainer, thumbnail);
            });
          }

          // Add click event to video wrapper
          videoWrapper.addEventListener("click", function (e) {
            toggleVideoPlayback(videoWrapper, videoContainer, thumbnail);
          });
        });
      }

      // Function to toggle video playback
      function toggleVideoPlayback(videoWrapper, videoContainer, thumbnail) {
        if (!videoWrapper || !videoContainer) return;

        const videoUrl = videoWrapper.getAttribute("data-video-url");
        const playOverlay = videoWrapper.querySelector(".video-play-overlay");
        if (!videoUrl) return;

        // Check if video is already created
        let video = videoContainer.querySelector("video");

        if (video) {
          // Video already exists, just toggle playback
          if (currentlyPlaying && currentlyPlaying !== video) {
            currentlyPlaying.pause();
            currentlyPlaying
              .closest("[data-video-handle]")
              .classList.remove("playing");
          }

          if (video.paused) {
            video
              .play()
              .then(() => {
                video.muted = false;
                videoWrapper.classList.add("playing");
                currentlyPlaying = video;
                // Hide thumbnail if it's still visible
                if (thumbnail && thumbnail.style.display !== "none") {
                  thumbnail.style.display = "none";
                }
              })
              .catch((err) => console.error("Video play failed:", err));
          } else {
            video.pause();
            videoWrapper.classList.remove("playing");
            currentlyPlaying = null;
          }
        } else {
          // Create video element for the first time
          if (currentlyPlaying) {
            currentlyPlaying.pause();
            currentlyPlaying
              .closest("[data-video-handle]")
              .classList.remove("playing");
            if (playOverlay) {
              playOverlay.style.display = "flex";
            }
          }

          // Show loading indicator
          const loader = createVideoLoader();
          videoContainer.appendChild(loader);
          if (playOverlay) {
            playOverlay.style.display = "none";
          }

          video = document.createElement("video");
          video.className = "review-video";
          video.setAttribute("playsinline", "");
          video.setAttribute("data-loaded", "true");
          video.setAttribute("data-keep-loaded", "true");

          const source = document.createElement("source");
          source.src = videoUrl;
          source.type = "video/mp4";
          video.appendChild(source);

          // Function to hide loader and show video
          const hideLoaderAndShowVideo = () => {
            if (loader && loader.parentNode) {
              loader.remove();
            }

            video
              .play()
              .then(() => {
                video.muted = false;
                videoWrapper.classList.add("playing");
                currentlyPlaying = video;

                // Hide thumbnail
                if (thumbnail) {
                  thumbnail.style.display = "none";
                }
              })
              .catch((err) => console.error("Video play failed:", err));
          };

          // Handle loading errors
          const onError = () => {
            if (loader && loader.parentNode) {
              loader.remove();
            }
            console.error("Failed to load video:", videoUrl);
          };

          video.addEventListener("canplay", hideLoaderAndShowVideo, {
            once: true,
          });
          video.addEventListener("loadeddata", hideLoaderAndShowVideo, {
            once: true,
          });
          video.addEventListener("error", onError, { once: true });

          videoContainer.appendChild(video);
          video.load();
        }
      }

      // Function to create video loader
      function createVideoLoader() {
        const loader = document.createElement("div");
        loader.className = "video-loading-indicator";
        loader.innerHTML = `
        <div class="video-loader-spinner"></div>
      `;
        return loader;
      }

      // Initialize videos after a short delay
      setTimeout(() => {
        initializeAllVideos();
        initializeVideoHandlers();
      }, 100);

      // Helper functions
      function getPositionX(event) {
        return event.type.includes("mouse")
          ? event.pageX
          : event.touches[0].clientX;
      }

      function pointerDown(e) {
        if (e.button !== 0) return;
        startDrag(e);
      }

      function touchStart(e) {
        startDrag(e);
      }

      function startDrag(e) {
        isDragging = true;
        startPos = getPositionX(e);
        if (animationID) {
          cancelAnimationFrame(animationID);
        }
        isAutoScrolling = false;
        slider.style.cursor = "grabbing";
        slider.classList.add("no-transition");
      }

      function pointerMove(e) {
        if (!isDragging) return;
        handleDrag(e);
      }

      function touchMove(e) {
        if (!isDragging) return;
        handleDrag(e);
      }

      function handleDrag(e) {
        const currentPos = getPositionX(e);
        currentTranslate = prevTranslate + currentPos - startPos;
        slider.style.transform = `translate3d(${currentTranslate}px,0,0)`;
      }

      function pointerUp() {
        endDrag();
      }

      function touchEnd() {
        endDrag();
      }

      function endDrag() {
        if (!isDragging) return;
        isDragging = false;
        slider.style.cursor = "grab";
        slider.classList.remove("no-transition");

        checkForReset();
        startAutoScroll();
      }

      // Optimized reset function - smoother for infinite scroll
      function checkForReset() {
        const boundary = originalContentWidth;

        // Optimized boundary checking - use simple modulo reset
        if (currentTranslate > -boundary * 0.5) {
          currentTranslate -= boundary;
          slider.style.transform = `translate3d(${currentTranslate}px,0,0)`;
        } else if (currentTranslate <= -boundary * 1.5) {
          currentTranslate += boundary;
          slider.style.transform = `translate3d(${currentTranslate}px,0,0)`;
        }

        prevTranslate = currentTranslate;
      }

      function startAutoScroll() {
        isAutoScrolling = true;
        let last = performance.now();

        const step = (now) => {
          if (!isAutoScrolling) return;

          const dt = now - last;
          last = now;

          if (!isDragging) {
            currentTranslate += autoScrollSpeed * (dt / 16); // normalise to 60 fps
            prevTranslate = currentTranslate;

            slider.style.transform = `translate3d(${currentTranslate}px,0,0)`;

            checkForReset();
          }
          animationID = requestAnimationFrame(step);
        };

        animationID = requestAnimationFrame(step);
      }

      // Pause videos when they go out of view
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const video = entry.target.querySelector("video");
            const wrapper = entry.target.querySelector("[data-video-handle]");
            const thumbnail = entry.target.querySelector(".video-thumbnail");

            if (!video || !wrapper) return;

            if (!entry.isIntersecting && !video.paused) {
              video.pause();
              wrapper.classList.remove("playing");

              // Show thumbnail again if video hasn't been loaded yet
              if (!video.hasAttribute("data-loaded") && thumbnail) {
                thumbnail.style.display = "block";
              }

              if (currentlyPlaying === video) {
                currentlyPlaying = null;
              }
            }
          });
        },
        { threshold: 0.5 }
      );

      allCards.forEach((card) => {
        observer.observe(card);
        videoLazyObserver.observe(card);
      });

      startAutoScroll();
    }
  });
});
